import type { SVGProps } from 'react';
export const Box = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path d="m16.23 6.26-5.5-3.01a1 1 0 0 0-.96 0l-5.5 3.01a1 1 0 0 0-.52.88v5.97a1 1 0 0 0 .52.88L9.77 17a1 1 0 0 0 .96 0l5.5-3.01a1 1 0 0 0 .52-.88V7.14a1 1 0 0 0-.52-.88m-5.98-2.14 5.02 2.75-5.02 2.76-5.02-2.76zm-5.5 3.63 5 2.74v5.36l-5-2.73zm6 8.1v-5.36l5-2.74v5.36z" />
  </svg>
);
